import { _ as _applyDecoratedDescriptor } from '../_rollupPluginBabelHelpers-3b0ba74f.js';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { guidFor } from '@ember/object/internals';
import { getOwner } from '@ember/application';
import { sanitizeHtml } from 'beebee-helper/helpers/safe-string';
import { i as isNuova, d as disabledTabIndex, e as explainDisabled } from '../nuova-disabled-e66e2b71.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';

var TEMPLATE = precompileTemplate("<div\n  class=\'checkbox checkbox-adv {{@class}} {{if @disabled \"disabled\"}}\'\n  role=\'checkbox\'\n  aria-checked=\'{{if @content \"true\" \"false\"}}\'\n  aria-disabled=\'{{if @disabled \"true\" \"false\"}}\'\n  aria-labelledby=\'{{this.labelId}}\'\n  tabindex={{this.tabIndex}}\n  title={{this.disabledReason}}\n  data-test-toggle-check\n  ...attributes\n  {{on \'click\' this.toggleCheck}}\n  {{on \'keydown\' this.handleKeydown}}\n>\n  <div class=\'check {{if @content \"checked\"}}\'>\n    <FaIcon @icon=\'check\' class=\'checked-icon\' />\n  </div>\n\n  <span id={{this.labelId}}>\n    {{this.labelEscape}}\n    {{#if @required}}\n      <span class=\'required\'>{{t \'required\'}}</span>\n    {{/if}}\n  </span>\n</div>\n{{#each this.hints as |hint|}}\n  <div class=\'checkbox-hint {{if hint.warning \"text-alert\"}}\'>{{hint.text}}</div>\n{{/each}}");

var _class;
let BbCheckboxComponent = (_class = class BbCheckboxComponent extends Component {
  get labelId() {
    return `checkbox-label-${guidFor(this)}`;
  }
  get isNuova() {
    return isNuova(getOwner(this));
  }
  get tabIndex() {
    return disabledTabIndex(this.args.disabled, Boolean(this.disabledReason));
  }

  // nuova only: the reason of a disabled box (classic keeps no explanation layer)
  get disabledReason() {
    return this.args.disabled && this.isNuova ? this.args.disabledReason || null : null;
  }
  get labelEscape() {
    // Labels may intentionally contain markup (icons, <b>): sanitize, don't escape.
    return this.args.label ? sanitizeHtml(this.args.label) : '';
  }

  /**
   * Optional explanatory hint(s) rendered under the checkbox, indented to the
   * label. `@hint` accepts a plain string or an array of strings /
   * `{ text, warning }` objects (warning entries render in the alert color).
   */
  get hints() {
    const hint = this.args.hint;
    if (!hint) {
      return [];
    }
    const list = Array.isArray(hint) ? hint : [hint];
    return list.filter(Boolean).map(entry => typeof entry === 'string' ? {
      text: entry,
      warning: false
    } : entry);
  }
  toggleCheck() {
    if (this.args.disabled) {
      explainDisabled(getOwner(this), this.disabledReason, this);
      return;
    }
    const newContent = !this.args.content;
    this.args.setContent?.(newContent);
    if (this.args.action) {
      this.args.action(newContent);
    }
  }
  handleKeydown(event) {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      this.toggleCheck();
    }
  }
}, _applyDecoratedDescriptor(_class.prototype, "toggleCheck", [action], Object.getOwnPropertyDescriptor(_class.prototype, "toggleCheck"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleKeydown", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleKeydown"), _class.prototype), _class);
setComponentTemplate(TEMPLATE, BbCheckboxComponent);

export { BbCheckboxComponent as default };
//# sourceMappingURL=bb-checkbox.js.map
